import { render, staticRenderFns } from "./ProjectOpportunityList.vue?vue&type=template&id=186e2346&"
import script from "./ProjectOpportunityList.vue?vue&type=script&lang=js&"
export * from "./ProjectOpportunityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports